export const payment = {
  field: {
    amount: 'Jumlah',
    comment: 'Info',
    date: 'Tanggal',
    description: 'Deskripsi',
    system: 'Sistem pembayaran',
    status: 'Status',
    type: 'Tipe pembayaran'
  },

  update_message:
    'Bagian sedang diperbarui dan akan muncul nanti. Tarif saat ini dapat diminta dari departemen dukungan.',

  status: {
    new: 'Baru',
    success: 'Sukses',
    failed: 'Gagal',
    failed_mc: 'Gagal',
    frozen: 'Beku'
  },
  titles: {
    operation_history: 'Riwayat operasi',
    top_up: 'Isi ulang',
    methods: 'Metode pembayaran'
  },
  errors: {
    email: 'Beberapa email tidak ditambahkan'
  },

  payment_system: {
    yoomoney: 'ЮMoney',
    pay_pal: 'PayPal',
    webmoney: 'WebMoney',
    capitalist: 'Capitalist',
    bank_card: 'Bank Card',
    internal: 'Internal',
    zorra: 'Zorra'
  },

  payment_type: {
    a_number_subscription_fee: 'Tagihan bulanan untuk penggunaan nomor {number}',
    a_number_connection_cost: 'Biaya untuk menghubungkan nomor {number}',
    referral_reward: 'Hadiah Referensi',
    pbx: 'Biaya bulanan untuk penggunaan paket PBX {package_name}',
    sms_number_verification: 'verifikasi SMS',
    voice_number_verification: 'Verifikasi dengan kode audio',
    phone_number_verification: 'Verifikasi berdasarkan digit terakhir nomor',
    call_number_verification: 'Verifikasi panggilan masuk',
    balance_refill: 'Isi ulang saldo',
    common: '',
    a_number: 'Tagihan bulanan untuk penggunaan nomor',
    mailing_sender: 'Penghapusan untuk menggunakan pengirim',
    hlr: 'HLR'
  }
};
